import ClubEmployeeDepartmentsAndTeams from '../dto/ClubEmployeeDepartmentsAndTeams';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubEmployeeDepartmentsAndTeamsRepository {
    static findByContext(clubId, context) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/employee-departments-and-teams/${context}`)
                .then((response) => resolve(ClubEmployeeDepartmentsAndTeams.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
